import { render, staticRenderFns } from "./SpecialistLicenses.vue?vue&type=template&id=c23be1f2&scoped=true"
import script from "./SpecialistLicenses.vue?vue&type=script&lang=js"
export * from "./SpecialistLicenses.vue?vue&type=script&lang=js"
import style0 from "./SpecialistLicenses.vue?vue&type=style&index=0&id=c23be1f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23be1f2",
  null
  
)

export default component.exports